<template>
  <div class="main">
    <!-- <div class="left-div">
      <img alt="宇罡科技" src="../../assets/logo-1.png" style="width:100px;height:100px;margin-top:50px;" />
      <p style="margin-top:30px;font-size:32px;color:#000;font-weight:bold;">宇罡智控管理平台</p>
      <p style="margin-top:30px;font-size:28px;color:#000;font-weight:bold;">万物互联 智慧管理</p>
    </div> -->
    <div class="user-layout-login">
      <p style="color:#fff;text-align:center;font-size:26px;padding-top:45px;">学生登录</p>
      <p style="color:#fff;text-align:center;font-size:20px;padding-bottom:20px;">欢迎使用</p>
      <a-form id="formLogin" ref="formLogin" :form="form" @submit="handleSubmit">
        <!-- 账户名 -->
        <a-form-item>
          <a-input
            size="large"
            type="text"
            placeholder="请输入帐户名"
            v-decorator="[
              'account',
              { rules: [{ required: true, message: '请输入帐户名' }], validateTrigger: 'change' }
            ]"
          >
            <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input>
        </a-form-item>

        <!-- 密码 -->
        <a-form-item>
          <a-input
            size="large"
            type="password"
            autocomplete="false"
            placeholder="请输入密码"
            v-decorator="['password', { rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur' }]"
          >
            <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input>
        </a-form-item>

        <!-- 验证码 -->
        <!-- <a-row :gutter="16">
          <a-col class="gutter-row" :span="15">
            <a-form-item>
              <a-input
                size="large"
                type="text"
                placeholder="请输入验证码"
                v-decorator="[
                  'captcha',
                  { rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur' }
                ]"
              >
                <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }" />
              </a-input>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="9">
            <img
              style="cursor:pointer;width:100px;height:40px;"
              title="点击刷新验证码"
              :src="'/admin.php/user/getCodePic?v=' + codeTimestamp"
              @click="refreshCode()"
            />
          </a-col>
        </a-row> -->

        <!-- 确定 -->
        <a-form-item style="margin-top:24px;float:right;">
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="login-button"
            :loading="state.loginBtn"
            :disabled="state.loginBtn"
          >登录</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'

export default {
  components: {},
  data() {
    return {
      loginBtn: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false
      },
      codeTimestamp: ''
    }
  },
  created() {},
  methods: {
    refreshCode() {
      this.codeTimestamp = new Date().getTime()
    },
    ...mapActions(['Login', 'Logout']),
    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        Login
      } = this

      state.loginBtn = true

      const validateFieldsKey = ['tenantCode', 'account', 'password', 'captcha']

      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          console.log('login form', values)
          const params = {
            tenantCode: values.tenantCode,
            account: values.account,
            code: values.captcha,
            password: values.password
          }
          Login(params)
            .then((res) => {
              _.get(res, 'code') === 200 ? this.loginSuccess(res) : this.requestFailed(res)
            })
            .catch((err) => this.requestFailed(err))
            .finally(() => {
              state.loginBtn = false
            })
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    loginSuccess(res) {
      this.$router.push({ path: '/' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
    },
    requestFailed(err) {
      this.$notification['error']({
        message: '错误',
        description: err.message || '请求出现错误，请稍后再试',
        duration: 4
      })
    }
  }
}
</script>

<style lang="less" scoped>
.left-div {
  float: left;
  width: 50%;
  height: 100%;
  background: #fff;
  opacity: 0.6;
  text-align: center;
}
.user-layout-login {
  background: rgba(3,9,27,.9);
  color: #fff;
  float: left;
  padding: 0 50px;
  width: 100%;
  height: 100%;
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 138px;
    background: #ca2942;
    border-color: #ca2942;
    border-radius: 23px;
    box-shadow: 0px 0px 20px 0px rgba(210, 14, 13, 0.3);
    color: #fff;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
